class IngredientsBenefits extends HTMLElement {
  constructor() {
    super();
    this.benefitButtons = null;
    this.subtitleList = null;
    this.benefitsData = [];
  }

  connectedCallback() {
    this.benefitButtons = this.querySelectorAll('.ingredients__benefit');
    this.subtitleList = this.querySelector('#ingredient-subtitle-list');

    // Get benefits data from window
    this.benefitsData = window.benefitsData || [];

    if (
      this.benefitButtons.length > 0 &&
      this.subtitleList &&
      this.benefitsData.length > 0
    ) {
      this.initEventListeners();
      // Render initial ingredients for first benefit
      this.renderIngredients(0);
    }
  }

  initEventListeners() {
    this.benefitButtons.forEach((button, index) => {
      button.addEventListener('click', () => this.handleBenefitClick(button, index));
    });
  }

  renderIngredients(benefitIndex) {
    const benefitData = this.benefitsData[benefitIndex];
    if (!benefitData || !benefitData.ingredientList) {
      this.subtitleList.innerHTML = '';
      return;
    }

    const ingredientNames = benefitData.ingredientList;
    const videoSeconds = benefitData.secondVideo || [];

    // Clear previous ingredients
    this.subtitleList.innerHTML = '';

    // Render each ingredient
    ingredientNames.forEach((ingredientName, index) => {
      // Cross-reference with ingredientsListData to get specific content
      let ingredientContent = ''; // Empty by default
      let matchedIngredient = null;

      if (window.ingredientsListData && window.ingredientsListData.length > 0) {
        matchedIngredient = window.ingredientsListData.find(
          item => item.title && item.title.toLowerCase() === ingredientName.toLowerCase()
        );

        if (matchedIngredient && matchedIngredient.content) {
          ingredientContent = matchedIngredient.content;
        } else {
          ingredientContent = 'No description available for this ingredient.';
        }
      } else {
        ingredientContent = 'Ingredient information not loaded.';
      }

      // Get video seconds for this ingredient (by index)
      const seconds = videoSeconds[index] || 0;

      // Create button
      const button = document.createElement('button');
      button.className = 'ingredients__ingredient-subtitle';
      button.setAttribute('data-ingredient-index', index);
      button.setAttribute('data-ingredient-name', ingredientName);
      button.setAttribute('data-video-seconds', seconds);
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', `ingredient-accordion-${index}`);

      const textSpan = document.createElement('span');
      textSpan.className = 'ingredients__ingredient-subtitle-text';
      textSpan.textContent = ingredientName;
      button.appendChild(textSpan);

      // Create accordion content
      const accordionContent = document.createElement('div');
      accordionContent.className = 'ingredients__accordion-content';
      accordionContent.id = `ingredient-accordion-${index}`;
      accordionContent.setAttribute('aria-hidden', 'true');

      const description = document.createElement('p');
      description.className = 'ingredients__ingredient-description';
      description.textContent = ingredientContent;
      accordionContent.appendChild(description);

      // Add event listener
      button.addEventListener('click', (e) => this.toggleAccordion(e.currentTarget));

      // Append to list
      this.subtitleList.appendChild(button);
      this.subtitleList.appendChild(accordionContent);
    });
  }

  toggleAccordion(subtitleButton) {
    const isExpanded = subtitleButton.getAttribute('aria-expanded') === 'true';
    const accordionId = subtitleButton.getAttribute('aria-controls');
    const accordionContent = document.getElementById(accordionId);

    if (!accordionContent) return;

    if (isExpanded) {
      // Close accordion
      subtitleButton.setAttribute('aria-expanded', 'false');
      accordionContent.setAttribute('aria-hidden', 'true');
      accordionContent.classList.remove('ingredients__accordion-content--open');
    } else {
      // Open accordion and jump to video timestamp
      subtitleButton.setAttribute('aria-expanded', 'true');
      accordionContent.setAttribute('aria-hidden', 'false');
      accordionContent.classList.add('ingredients__accordion-content--open');

      // Jump to video timestamp
      const videoSeconds = subtitleButton.getAttribute('data-video-seconds');
      this.jumpToVideoTimestamp(videoSeconds);
    }
  }

  jumpToVideoTimestamp(seconds) {
    const timestamp = parseFloat(seconds) || 0;

    if (timestamp > 0) {
      // Find the video element
      const videoElement = document.querySelector('ingredients-video');

      if (videoElement && videoElement.skipTo) {
        videoElement.skipTo(timestamp);
      } else {
        console.warn('Video element not found or skipTo method not available');
      }
    } else {
      console.warn('No valid timestamp found for this ingredient');
    }
  }

  handleBenefitClick(button, index) {
    this.benefitButtons.forEach((btn) => {
      btn.classList.remove('ingredients__benefit--active');
    });
    button.classList.add('ingredients__benefit--active');

    // Get data from benefitsData array
    const benefitData = this.benefitsData[index];

    if (benefitData) {
      this.updateContent(index);
    }
  }

  updateContent(benefitIndex) {
    this.subtitleList.style.opacity = '0';

    setTimeout(() => {
      // Render ingredients for the selected benefit
      this.renderIngredients(benefitIndex);

      this.subtitleList.style.opacity = '1';
    }, 150);
  }
}

customElements.define('ingredients-benefits', IngredientsBenefits);
